<template>
  <p class="footer">
    <span>{{ team }}</span>
    <span class="mail">
      {{ mail }}
    </span>
    <a
      href="mailto:lighthouse@royole.com"
    >
      {{ mailAddress }}
    </a>
  </p>
</template>

<script>
export default {
  data() {
    return {
      team: '©2019 柔宇科技 IT 互联网团队',
      mail: '反馈建议请发送邮件至：',
      mailAddress: 'lighthouse@royole.com',
    };
  },
};
</script>

<style lang="scss" scoped>
.footer{
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0;
  color: #9da5c2;
  text-align: center;
  .mail{
    margin-left: 20px;
  }
}
</style>
